'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buildLatestMessage;

var _PubNubMessageFactory = require('conversations-schema/factories/PubNubMessageFactory');

/**
 * Build a latest message record
 * 
 * @param {Object|Map|PubNubMessageRecord} [props] - Properties to build the latest message from
 * @return {PubNubMessageRecord|null}
 *
 */
function buildLatestMessage(props) {
  if (!props) return null;
  return (0, _PubNubMessageFactory.buildPublishedMessage)(props);
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/factories/ConversationFactory/buildLatestMessage.js
// module id = 301
// module chunks = 0 1